import { render, staticRenderFns } from "./orders-list-table-head.component.vue?vue&type=template&id=37575192&scoped=true"
import script from "./orders-list-table-head.component.vue?vue&type=script&lang=js"
export * from "./orders-list-table-head.component.vue?vue&type=script&lang=js"
import style0 from "./orders-list-table-head.component.vue?vue&type=style&index=0&id=37575192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37575192",
  null
  
)

export default component.exports